module.exports = __webpack_public_path__ + "static/media/life-leader-board-banner-desktop.1ad244bb.jpg";